import {Outlet} from 'react-router-dom';

import {ShopContext} from './Shop';
import {ShopLocalesAndMarkets} from './ShopLocalesAndMarkets';
import {MonorailProvider as Monorail} from './Monorail/Monorail';

export function RootProviders() {
  return (
    <ShopContext>
      <Monorail>
        <ShopLocalesAndMarkets>
          <Outlet />
        </ShopLocalesAndMarkets>
      </Monorail>
    </ShopContext>
  );
}
